
<div class="container mt-lg-4">
  <fgbcl-marketplace-list
    [isList]="true"
    [showSortBar]="false"
    [marketplaceItemTypes]="[3, 5]"
    [eventItemView]="true"
  ></fgbcl-marketplace-list>
</div>
